export default __webpack_public_path__ + "static/media/wordcloud.46d6051d.webp";